import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import VideoPlayer from 'aria-viewer/players/videoplayer/videoPlayerWrapper'
import PanoPlayerWrapper from 'aria-viewer/players/panoplayer/containers/panoPlayerWrapper'
import InteractiveElementsContainer from '../../interactive-element/containers/common/InteractiveElements'
import AspectHelper from './aspectHelper'
import { INTERACTIVE_ELEMENT_OPTIONS } from 'aria-viewer/interactive-element'
import { MEDIA_TYPES as types } from 'aria-viewer/tour/constants/index'
import pure from 'recompose/pure'
import { WithForwardRef } from 'aria-viewer/common'
import InstagramViewer from 'aria-viewer/tour/components/InstagramViewer'

class MediaComponent extends PureComponent {
    render() {
        /*
			TODO
			Figure out which parent is passing null options
		 */
        const options = this.props.options || {}
        const {
            onLoad,
            onRotate,
            positionalmedia,
            secondaryOptions,
            sizes,
            style,
            active,
            enableInteractiveElements,
            forwardRef,
        } = this.props
        const mediaType = options.network || options.mediaType || (options.mainMedia && options.mainMedia.mediaType)
        const _aspect = options.aspect || 'bestfit'

        switch (mediaType) {
            case types.panorama:
                return (
                    <PanoPlayer
                        onLoad={onLoad}
                        onRotate={onRotate}
                        options={options}
                        enableInteractiveElements={enableInteractiveElements}
                        positionalmedia={positionalmedia}
                        secondaryOptions={secondaryOptions}
                        sizes={sizes}
                        style={style}
                        active={active}
                    />
                )

            // TODO | Do not simply funnel "...props";
            // TODO | adds unnecessary debug complexity
            // TODO | and cannot control PureComponent
            // TODO | data flow so easily
            case types.video:
                return <VideoPlayer {...this.props} />
            case types.photo:
                return (
                    <AspectHelper ref={forwardRef} aspect={_aspect} {...this.props}>
                        <InteractiveElementsContainer
                            enableInteractiveElements={enableInteractiveElements}
                            contextType={INTERACTIVE_ELEMENT_OPTIONS.CONTEXT.context2D}
                        />
                    </AspectHelper>
                )
            case types.instagram:
                return (
                    <InstagramViewer
                        media={options}
                        inst_id={options.inst_id}
                        loc_id={options.loc_id}
                        onLoad={this.props.onLoad}
                    />
                )
            default:
                return null
        }
    }
}
const PanoPlayer = pure(function PanoPlayer({
    onLoad,
    onRotate,
    options,
    positionalmedia,
    enableInteractiveElements,
    secondaryOptions,
    sizes,
    style,
    active,
}) {
    return (
        <PanoPlayerWrapper
            {...{
                onLoad,
                onRotate,
                options,
                positionalmedia,
                enableInteractiveElements,
                secondaryOptions,
                sizes,
                style,
                active,
            }}
        />
    )
})

MediaComponent.propTypes = {
    enableInteractiveElements: PropTypes.bool,
}

MediaComponent.defaultProps = {
    enableInteractiveElements: true,
}

export default WithForwardRef(MediaComponent)
